import {CircularProgress}  from "@mui/material";

const CircularProgressBar = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.8)", // Use an rgba value for background color with some transparency
        zIndex: 9999, // Higher z-index to appear on top
      }}
    >
      <CircularProgress style={{ color: "#45C2B1" }} size={70} />
    </div>
  );
};

export default CircularProgressBar;
